import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LogOut, UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AccountsTab = ({ getCurrentUserLabel, predefinedAccounts, handleQuickSwitch }) => {
   const navigate = useNavigate();

   return (
      <Card>
         <CardHeader>
            <CardTitle>Quick Account Switch</CardTitle>
            <CardDescription>Current User: {getCurrentUserLabel()}</CardDescription>
         </CardHeader>
         <CardContent className="grid grid-cols-2 gap-4">
            {predefinedAccounts.map((account) => (
               <Button
                  key={account.username}
                  variant="outline"
                  className="justify-start"
                  onClick={() => handleQuickSwitch(account)}
               >
                  <UserPlus className="mr-2 h-4 w-4" />
                  {account.label}
               </Button>
            ))}
            <Button
               variant="destructive"
               className="col-span-2"
               onClick={() => {
                  localStorage.removeItem('token');
                  localStorage.removeItem('user');
                  navigate('/auth');
               }}
            >
               <LogOut className="mr-2 h-4 w-4" />
               Logout
            </Button>
         </CardContent>
      </Card>
   );
};

export default AccountsTab;